<template>
	<div>
		<div class="content-box">
			<el-card class="card-container m-t-20" shadow="never">
				<el-form :model="formInline" :rules="rules" ref="ruleForm" class="search-form" label-width="100px">
					<el-form-item label="订单类型" prop="source">
						<el-select class="w350" v-model="formInline.source" placeholder="请选择订单类型" @change="sourceChange">
							<el-option v-for="item in ENUM.HEADER_TAB" :label="item.label" :value="item.value"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="所属平台" prop="type_new">
						<el-select class="w350" v-model="formInline.type_new" placeholder="请选择平台">
							<el-option v-for="item in ENUM.PLAT_LIST" :label="item.label" :value="item.value"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="订单状态" prop="status">
						<el-select class="w350" v-model="formInline.status" placeholder="请选择订单状态">
							<el-option v-for="item in ENUM.STATUS_LIST" :label="item.label" :value="item.value"
								:key="item.value"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item label="付款时间">
						<el-date-picker v-model="formInline.range" type="daterange" align="right" unlink-panels
							range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" value-format="timestamp"
							clearable @change="handleChangeDate">
						</el-date-picker>
					</el-form-item>
				</el-form>
			</el-card>
			<el-card class="card-container m-t-20 lh-26" shadow="never">
				<div class="font14 color6">注意:</div>
				<div class="font13 color9">1、每个订单下载任务的时间范围最多可选择31天</div>
				<div class="font13 color9">2、点击提交任务后，请在下载记录里查看数据，导出成功状态的可点击下载，每天最多可导出3次</div>
				<div class="font13 color9">3、提交任务后，可关闭窗口，再次进入窗口后，在下载记录中查看即可</div>
				<div class="font13 color9">4、如果数据量级太大，文件会拆分成多个表格。文件过大可能会下载失败，建议缩小数据范围再次尝试</div>
				<div class="font13 color9">5、下载记录保留30天，30天后需要重新生成数据</div>
			</el-card>
		</div>

		<div class="bottom-box">
			<el-button type="primary" :disabled="btnStatus" @click="handleSubmit">提交下载任务</el-button>
			<el-button @click="handleClose">取消</el-button>
		</div>
	</div>

</template>

<script>
import { ENUM } from '@/utils/enum'
import { exportLast, exportApply } from '@/api/public'
import { getDayRangeBySetHours } from '@/utils/timeTransfer'
export default {
	props: {
		isShow: {
			type: Boolean,
			default: false
		},
		teamType: {
			type: [Number, String],
			default: 1
		},
		parames: {
			type: Object,
			default: () => ({})
		},
	},
	computed: {
		drawerVisible: {
			get() {
				return this.isShow
			},
			set(val) {

			}
		},
	},
	data() {
		return {
			ENUM,
			formInline: {
				status: 0,
				range: [],
				type_new: 0,
				timestamp:[],
				source:1
			},
			rules: {
				type_new: [
					{ required: true, message: '请选择平台', trigger: 'change' }
				],
				status: [
					{ required: true, message: '请选择订单状态', trigger: 'change' }
				],
				source: [
					{ required: true, message: '请选择订单类型', trigger: 'change' }
				]
			},
			isProgress: false,

		}
	},
	computed: {
		btnStatus(){
			let status = this.isProgress || !(this.formInline.type_new >= 0) || !(this.formInline.status>=0)
			return status
			
		}
	},
	async mounted() {
		this.formInline.type_new = Number(this.parames.type_new)||0
		this.formInline.status = Number(this.parames.status)||0
		this.formInline.range = this.parames.range || []
		this.formInline.timestamp = this.parames.timestamp || []
		this.formInline.source = Number(this.teamType)||1
		if (this.formInline.range.length>0){
			let res = await this.dataRang(this.formInline.range)
			if (!res) {
				this.formInline.range = []
				this.formInline.timestamp = []
			}
		}
		this.getLast()
	},
	methods: {
		setDefaultDate(){
			const today = new Date();
			const oneMonthAgo = new Date();
			oneMonthAgo.setMonth(today.getMonth() - 1);

			// 设置默认日期范围
			this.formInline.range = [
				oneMonthAgo.getTime(),
				today.getTime()
			];

			// 触发日期变更处理逻辑
			this.handleChangeDate(this.formInline.range);
		}, 
		getLast(){
			exportLast({ source: this.formInline.source}).then(res => { 
				if (res.data && res.data.task_status){
					this.isProgress = res.data.task_status==1||res.data.task_status==2?true:false
					}
				})
		},
		sourceChange(){
			this.getLast()
		},
		handleClose() {
			this.$emit('close')
		},
		async handleChangeDate(val) {
			this.formInline.timestamp = []
			if (val && val.length === 2) {
				let res = await this.dataRang(val)
				if (!res){
					this.$message.warning('时间范围不能超过31天，请重新选择');
					this.formInline.range = [];
					this.formInline.timestamp = []
					return false
				}
				let obj = getDayRangeBySetHours(val[0], val[1])
				this.formInline.timestamp.push(Math.floor(obj.start / 1000))
				this.formInline.timestamp.push(Math.floor(obj.end / 1000))
			}
		},
		dataRang(val){
			return new Promise((resolve, reject) => {
				const startDate = val[0];
				const endDate = val[1];
				const diffTime = Math.abs(endDate - startDate);
				const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

				if (diffDays > 31) {
					
					resolve(false)
				}else{
					resolve(true)
				}
			})
		},
		handleSubmit() {
			this.$refs.ruleForm.validate((valid) => {
				if (valid) {
					let obj= {
						type_new: this.formInline.type_new,
						status: this.formInline.status,
						create_start: this.formInline.timestamp.length>0?this.formInline.timestamp[0] : 0,
						create_end: this.formInline.timestamp.length>1?this.formInline.timestamp[1] : 0,
					}
					exportApply({
						source: this.formInline.source,
						paramsJson: JSON.stringify(obj)
					}).then(res => {
						if(res.code==1){
							this.$message.success('提交成功');
							this.$emit('ok')
						}
						
					});
				} 
			});
		}
	}
}
</script>

<style scoped lang="scss">
.content-box {
	padding-bottom: 80px;
}

.bottom-box {
	width: 800px;
	position: fixed;
	bottom: 0;
	right: 0;
	padding: 10px 20px;
	background-color: #f8f9fa;
	box-shadow: 0 -2px 12px 0 rgba(0, 0, 0, 0.1);
}

.w350 {
	width: 350px;
}
</style>
